module.exports = __webpack_public_path__ + "/assets/create_widget.png";


/*****************
 ** WEBPACK FOOTER
 ** ../src/dash/front/styles/images/create_widget.png
 ** module id = 1064
 ** module chunks = 0
 **/